module.exports = __webpack_public_path__ + "static/img/YB-20V.4e2afba3.png";